import { SolutionDeletionSettingCard } from "@/components/admin/SolutionDeletionSettingCard";
import { Card, CardContent } from "@/components/ui/card";

export function SettingsSystemPage() {
  return (
    <Card className="border-border/50">
      <CardContent className="py-6">
        <SolutionDeletionSettingCard />
      </CardContent>
    </Card>
  );
}
